import { doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { db, storage } from './firebase';

const BRANDING_DOCUMENT = doc(db, 'config_apariencia', 'main');
export const OFFICIAL_ASSETS = {
  logo: '/logo.png?v=3',
  favicon: '/favicon-32x32.png?v=3',
  pwa192: '/icons/icon-192x192.png?v=3',
  pwa512: '/icons/icon-512x512.png?v=3',
  maskable: '/icons/icon-maskable-512x512.png?v=3',
  ogImage: '/og-image.png?v=3'
};
export const BRANDING_STORAGE_KEY = 'suite-branding-assets-v3';

const DEFAULT_BRANDING = {
  logoUrl: OFFICIAL_ASSETS.logo,
  pwaLogoUrl: OFFICIAL_ASSETS.logo,
  faviconUrl: OFFICIAL_ASSETS.favicon,
  pwa192Url: OFFICIAL_ASSETS.pwa192,
  pwa512Url: OFFICIAL_ASSETS.pwa512,
  maskableUrl: OFFICIAL_ASSETS.maskable,
  ogImageUrl: OFFICIAL_ASSETS.ogImage,
  assets: {},
  updatedAt: null
};

const fieldByKind = {
  logo: 'logoUrl', favicon: 'faviconUrl', pwa192: 'pwa192Url',
  pwa512: 'pwa512Url', maskable: 'maskableUrl', ogImage: 'ogImageUrl'
};

function readLocalAssets() {
  try { return JSON.parse(localStorage.getItem(BRANDING_STORAGE_KEY) || '{}'); } catch { return {}; }
}

function normalizedBranding(data = {}) {
  // Las antiguas claves pwaLogoUrl/faviconUrl no se usan como override: solo assets v3 explícitos.
  const assets = { ...readLocalAssets(), ...(data.assets || {}) };
  const next = { ...DEFAULT_BRANDING, ...data, assets };
  Object.entries(fieldByKind).forEach(([kind, field]) => {
    next[field] = kind === 'favicon' ? OFFICIAL_ASSETS.favicon : (assets[kind] || OFFICIAL_ASSETS[kind]);
  });
  next.pwaLogoUrl = next.logoUrl;
  return next;
}

export function subscribeToBranding(onChange, onError) {
  return onSnapshot(BRANDING_DOCUMENT, snapshot => onChange(normalizedBranding(snapshot.exists() ? snapshot.data() : {})), onError);
}

export async function saveBrandingAssets(assets, userId) {
  const current = { ...readLocalAssets(), ...assets };
  localStorage.setItem(BRANDING_STORAGE_KEY, JSON.stringify(current));
  await setDoc(BRANDING_DOCUMENT, { assets: current, updatedBy: userId || null, updatedAt: serverTimestamp() }, { merge: true });
  return normalizedBranding({ assets: current });
}

const withTimeout = (promise, milliseconds = 10000) => Promise.race([
  promise,
  new Promise((_, reject) => setTimeout(() => reject(new Error('Tiempo de espera agotado al subir la imagen.')), milliseconds))
]);

export async function uploadBrandingAsset(kind, blob, userId) {
  if (!fieldByKind[kind]) throw new Error('Activo visual no válido.');
  const extension = kind === 'ogImage' ? 'jpg' : 'png';
  try {
    const storageRef = ref(storage, `suite-branding/${kind}.${extension}`);
    await withTimeout(uploadBytes(storageRef, blob, { contentType: blob.type || 'image/png', cacheControl: 'no-cache, max-age=0' }));
    const downloadUrl = await withTimeout(getDownloadURL(storageRef));
    await saveBrandingAssets({ [kind]: `${downloadUrl}${downloadUrl.includes('?') ? '&' : '?'}v=${Date.now()}` }, userId);
    return { storage: true };
  } catch (error) {
    throw error;
  }
}

